import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import ScrollToTop from 'common/ScrollToTop';
import { RENEWAL, RENEWAL_CONFIRMATION } from 'constants/routeConstants';
import BackButton from 'shared/components/BackButton/BackButton';
import useViewport from 'utils/useViewportHelper';
import Header from 'views/MyRac/ExpiryRenewal/components/organisms/Header';

const RenewalsView = () => {
  const { isAppView } = useSelector((state) => state?.content?.flags);
  const { policyInfo } = useSelector((state) => state.policy);

  const { isMobile } = useViewport();

  const navigate = useNavigate();

  const location = useLocation();

  // Use truthy condition to show back button
  const isRenewalStep = location.pathname !== RENEWAL && location.pathname !== RENEWAL_CONFIRMATION;

  // Alternative telephone numbers are to be shown for users of either 1-2 or 3+ years membership
  const tenureTelNo = policyInfo?.yearsOfMembership < 3 ? '0330 159 1417' : '0330 159 8529';

  if (isAppView) {
    return (
      <>
        {isRenewalStep && (
          <div className="container bg-grey py-1">
            <BackButton onClickHandler={() => navigate(-1)} />
          </div>
        )}
        <div className="container bg-grey p-0" style={{ minHeight: '100vh' }}>
          <ScrollToTop />
          <Outlet />
        </div>
      </>
    );
  }

  return (
    <>
      <Header telNo={tenureTelNo} />
      <div className={`d-flex justify-content-center bg-grey ${isMobile ? 'py-2' : 'py-4'}`} style={{ minHeight: '87vh' }}>
        <div style={{ width: isMobile ? '90%' : '800px' }}>
          <div className={`container ${isMobile ? 'p-0' : 'pb-3'}`}>
            {isRenewalStep ? (
              <BackButton onClickHandler={() => navigate(-1)} />
            ) : <div className={`${isMobile ? 'py-2' : 'p-0'}`} />}
          </div>
          <div className="container rounded bg-white p-0 m-0">
            <ScrollToTop />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default RenewalsView;
